import HELPER from '@/app/utils/HELPER';
import { checkKeyValid } from '@/app/utils/checkRoleApply';

export default function ($gfLeftSideBar, $gryffBody, $element, _this, $formElement, index, _data) {
  const attrName = $formElement.attr('name');

  // if input has no-render => no render;
  if ($formElement.hasClass('no-render')) {
    $formElement.hide();
    return false;
  }
  if (
    attrName == 'cId' ||
    attrName == 'cHandle' ||
    attrName == 'pid' ||
    attrName == 'pHandle' ||
    attrName == 'bId' ||
    attrName == 'bHandle'
  ) {
    return false;
  }

  let _title = '';
  let dataCount = 1;
  if (checkKeyValid('checkDataCaptionSwitcherRenderSnippets')) {
    dataCount = 0;
  }
  if ($element.hasClass('columns-advanced')) {
    // titile in advanced always show.
    _title = $formElement.attr('data-caption');
  } else if ($element.find('.gf-options').length > 0) {
    // gfOptions always show titile;
    _title = $formElement.attr('data-caption');
  } else if ($formElement.attr('data-caption') && _data['count'] > dataCount) {
    _title = $formElement.attr('data-caption');
  }

  switch (attrName) {
    case 'page':
      $formElement.gfPageSelector({
        detectChange: function () {},
      });
      break;

    case 'meta':
      $formElement.gfMetaSelector({
        detectChange: function () {},
      });
      break;

    case 'article':
      $formElement.gfArticleSelector({
        detectChange: function () {},
      });
      break;

    case 'collection':
      $formElement.gfCollectionSelector({
        // COLLECTION 2019
        detectChange: function () {
          if ($gfLeftSideBar.find('#dynamic').length > 0) {
            const dynamic = parseInt($gfLeftSideBar.find('#dynamic').val());
            if (dynamic == 1) {
              setTimeout(function () {
                const $gryffEditor = $gryffBody.find('.gryffeditor').first();
                $gryffEditor
                  .find(
                    '.module-wrap[data-label="Collection Banner"], .module-wrap[data-label="Collection Title"], .module-wrap[data-label="Collection Desc"], .module-wrap[data-label="Collection Toolbar"]',
                  )
                  .each(function (index, module) {
                    if (jQuery(module).data('gfmodule') != undefined) {
                      jQuery(module).data('gfmodule').refresh();
                    }
                  });
              }, 500);
            }
          }
        },
      });
      break;

    case 'blog':
      $formElement.gfBlogSelector({
        detectChange: function () {},
      });
      break;

    case 'editLink':
      var options = {
        position: $gfLeftSideBar.children().width() + 'px 0',
        option: option,
        detectChange: function () {},
        onOpacity: function () {
          _this.onOpacity();
        },
        offOpacity: function () {
          _this.offOpacity();
        },
      };
      var option = typeof $formElement.attr('data-option') !== 'undefined' ? $formElement.attr('data-option') : null;
      if (option) {
        const optionArray = option.split('|');
        option = optionArray[0];
        for (let i = 1; i < optionArray.length; i++) {
          options[optionArray[i]] = true;
        }
      }
      $formElement.gfLinkPicker(options);

    case 'continue':
      var option = typeof $formElement.attr('data-option') !== 'undefined' ? $formElement.attr('data-option') : null;
      $formElement.gfLinkPicker({
        position: $gfLeftSideBar.children().width() + 'px 0',
        option: option,
        detectChange: function () {},
        onOpacity: function () {
          _this.onOpacity();
        },
        offOpacity: function () {
          _this.offOpacity();
        },
      });
      break;

    case 'swatch-hide':
      var list_options = [];
      var moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
      var $productSwatches = $gryffBody.find('#m-' + moduleId);
      var $product = $productSwatches.closest('[data-label="Product"]');
      if ($product.children('[data-pid]').length > 0) {
        const productId = $product.children('[data-pid]').attr('data-pid');
        const productData = HELPER.searchProductInList(productId);
        const jsonHtml = '{ "product": ' + JSON.stringify(productData) + '}';
        try {
          const data = jQuery.parseJSON(jsonHtml);
          const swatches = [];
          var options = data['product']['options'];
          for (var j = 0; j < options.length; j++) {
            list_options.push(options[j].name);
          }
        } catch (err) {
          console.log(err.message);
        }
      }

      $formElement.children('option').each(function () {
        const value = jQuery(this).text();
        const index = list_options.indexOf(value);
        if (index !== -1) {
          list_options.splice(index, 1);
        }
      });
      if (list_options.length > 0) {
        for (var j = 0; j < list_options.length; j++) {
          $formElement
            .children('option')
            .eq(0)
            .after('<option value="' + list_options[j] + '">' + list_options[j] + '</option>');
        }
      }
      break;

    case 'timezone':
      if ($formElement.attr('value') == '') {
        const d = new Date();
        $formElement
          .attr('value', 'UTC' + (d.getTimezoneOffset() > 0 ? '-' : '+') + Math.abs(d.getTimezoneOffset()) / 60)
          .trigger('input-change')
          .trigger('value-change');
      }
      break;
  }

  if ($formElement.hasClass('column-size-resizer')) {
  } else if ($formElement.attr('name') == 'box-shadow-angle') {
    $formElement.gfShadowAngle({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_popup-trigger-hint')) {
    $formElement.hide();
    $formElement.after(
      '<span class=\'gfDesc\'>Popups with trigger option of "Show when add a product to cart" will show up. You should set this option for one popup only.</span>',
    );
  } else if ($formElement.hasClass('gf_get-generate-token')) {
    $formElement.gfGenerateTokenInstagram({
      title: _title,
    });
  } else if (attrName == 'background-v2') {
    $formElement.gfBackgroundV2({
      title: _title,
    });
  } else if (attrName == 'cbTo') {
    $formElement.gfAjaxCartOptiops({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_to-preview-popup') || $formElement.hasClass('gf_to-cookie-popup')) {
    $formElement.gfSettingsPopup();
  } else if ($formElement.hasClass('gf-options')) {
    $formElement.gfOptions({
      title: _title,
      detectChange: function () {},
    });
  } else if (attrName == 'variant') {
    $formElement.gfVariantSelector({
      detectChange: function () {},
    });
  } else if (attrName == 'product') {
    $formElement.gfProductSelector({
      detectChange: function () {},
    });
  } else if (attrName == 'swatcherv1') {
    $formElement.gfSwatcherV1({
      detectChange: function () {},
    });
  } else if (attrName == 'arv6picker') {
    $formElement.gfArv6SectionPicker({
      detectChange: function () {},
    });
  } else if (attrName == 'swatcher') {
    $formElement.gfSwatcher({
      onOpacity: function () {
        _this.onOpacity();
      },
      offOpacity: function () {
        _this.offOpacity();
      },
      detectChange: function () {},
    });
  } else if (attrName == 'gravity') {
    $formElement.gfGravity({
      title: _title,
      onOpacity: function () {
        _this.onOpacity();
      },
      offOpacity: function () {
        _this.offOpacity();
      },
    });
  } else if (attrName == 'position') {
    $formElement.gfDropDown({
      title: _title,
      onOpacity: function () {
        _this.onOpacity();
      },
      onSelected: function (value, $element) {
        const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
        const $targetElement = $gryffBody.find('#' + merId);
        $targetElement.removeClass('gf_position-fixed');
        if (value == 'fixed') {
          $targetElement.addClass('gf_position-fixed');
          $targetElement.positionFixed();
        }
      },
      offOpacity: function () {
        _this.offOpacity();
      },
    });
  } else if ($formElement.hasClass('gf-to-shadowXY')) {
    $formElement.gfShadowXY();
  } else if ($formElement.hasClass('gf-shadow-style')) {
    $formElement.gfShadowStyle();
  } else if ($formElement.hasClass('gf-border-radius')) {
    $formElement.gfBorderRadiusAll();
  } else if ($formElement.hasClass('gf-border-width')) {
    $formElement.gfBorderWidthAll();
  } else if ($formElement.hasClass('gf_to-segment')) {
    $formElement.gfSegment({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_to-backgroundPosition')) {
    $formElement.gfBackgroundPosition({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_field-display')) {
    $formElement.gfResDisplay({
      title: _title,
      onSelected: function (value) {},
    });
  } else if ($formElement.hasClass('gf_to-switch')) {
    // dynamic option in Product Module
    let merTitle = '';
    const $gfFrame = jQuery('#gfFrame');
    const $panel = $gfLeftSideBar.find('#md-settings');
    if ($panel.length > 0) {
      merTitle = jQuery.trim($panel.find('.md-title .mer-title').text());
    }
    const pageType = $gfFrame.data('gfframe').getPageType();
    if (
      ($formElement.attr('name') == 'dynamic' || $formElement.attr('name') == 'default') &&
      (merTitle == 'Product' || merTitle == 'Related Products') &&
      pageType != 'template-product'
    ) {
      $formElement.hide();
      $formElement.after('<div class="gfDesc">Dynamic option is available for product template only.</div>');
      const $settingPanel = $formElement.closest('.settings-panel');
      $settingPanel.find('.gfDesc .dynamic-desc').closest('.columns').hide();
      // COLLECTION 2019
    } else if (
      $formElement.attr('name') == 'dynamic' &&
      merTitle == 'Product List' &&
      pageType != 'template-collection'
    ) {
      $formElement.hide();
      $formElement.after('<div class="gfDesc">Dynamic option is available for collection template only.</div>');
    } else if (
      $formElement.attr('name') == 'dynamic' &&
      merTitle == 'Product List' &&
      pageType == 'template-collection'
    ) {
      var value = '';
      if ($formElement.attr('value')) {
        value = $formElement.attr('value');
      }
      $formElement.gfSwitcher({
        title: _title,
        value: value,
        onSelected: function (value, $element) {
          setTimeout(function () {
            const $gryffEditor = $gryffBody.find('.gryffeditor').first();
            $gryffEditor
              .find(
                '.module-wrap[data-label="Collection Banner"], .module-wrap[data-label="Collection Title"], .module-wrap[data-label="Collection Desc"], .module-wrap[data-label="Collection Toolbar"]',
              )
              .each(function (index, module) {
                if (jQuery(module).data('gfmodule') != undefined) {
                  jQuery(module).data('gfmodule').refresh();
                }
              });
          }, 500);
        },
      });
    } else if ($formElement.attr('name') == 'preview' && merTitle == 'Paginator') {
      // other switches
      var value = '';
      if ($formElement.attr('value')) {
        value = $formElement.attr('value');
      }
      $formElement.gfSwitcher({
        title: _title,
        value: value,
        enable: false,
      });
    } else {
      // other switches
      var value = '';
      if ($formElement.attr('value')) {
        value = $formElement.attr('value');
      }
      $formElement.gfSwitcher({
        title: _title,
        value: value,
      });
    }
  } else if ($formElement.hasClass('gryff-color')) {
    var value = '',
      hide = '';
    if ($formElement.attr('value')) {
      value = $formElement.attr('value');
    }
    if ($formElement.attr('data-hide')) {
      hide = $formElement.attr('data-hide');
    }
    $formElement.gfColorPicker({
      title: _title,
      value: value,
      hide: hide,
      onOpacity: function () {
        _this.onOpacity();
      },
      offOpacity: function () {
        _this.offOpacity();
      },
    });
  } else if ($formElement.hasClass('gf_to-range')) {
    $formElement.gfRangePicker({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_to-photoPicker')) {
    // Cho stater dùng upload care
    $formElement.gfPhotoPicker({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_row-layout')) {
    // open leftsidebar settings again
    if ($gfLeftSideBar != undefined) {
      const edittingID = $gfLeftSideBar.find('#md-settings').data('edittingID');
      if (edittingID && $gryffBody.find('#' + edittingID).length > 0) {
        const $activeRow = $gryffBody.find('#' + edittingID);
        $formElement.gfColumnChooser({
          row: $activeRow,
          position: $gfLeftSideBar.children().width() + 'px 0',
          onSelected: function (cText) {},
        });
      }
    }
  } else if ($formElement.hasClass('gf_margin') || $formElement.hasClass('gf_padding')) {
    $formElement.gfMarginPadding({
      onSelected: function (value) {},
    });
  } else if ($formElement.hasClass('gf_border-width') || $formElement.hasClass('gf_border-radius')) {
    $formElement.gfBorderWidth({
      onSelected: function (value) {},
    });
  } else if ($formElement.hasClass('gf_font')) {
    $formElement.gfFontPicker({
      title: _title,
    });
  } else if ($formElement.hasClass('gf_to-iconPicker')) {
    const $iconPicker = jQuery(
      '<div class="add-icon-box"> <a href="#" class="selected-icon"> <i class="gf_icon fa fa-bell" aria-hidden="true"></i> </a> <a href="#" class="button gfIconPicker">Choose Icon...</a> </div>',
    );
    $formElement.hide();
    $formElement.next('.add-icon-box').remove();

    if ($formElement.attr('value')) {
      const icon = HELPER.base64UrlDecode($formElement.attr('value'));
      $iconPicker.children('.selected-icon').html(icon);
    }
    $formElement.on('value-change', function () {
      const icon = HELPER.base64UrlDecode($formElement.attr('value'));
      $iconPicker.children('.selected-icon').html(icon);
    });
    $iconPicker
      .off('click')
      .on('click', function () {
        jQuery('<div/>').gfIconPicker({
          position: $gfLeftSideBar.children('.side-panels').innerWidth() + 'px 0',
          onSuccess: function (icon) {
            $formElement.attr('value', HELPER.base64UrlEncode(icon)).trigger('input-change');
            $formElement.trigger('history-change');
            $iconPicker.children('.selected-icon').html(icon);
          },
        });
        return false;
      });
    $iconPicker.insertAfter($formElement);
  } else if ($formElement.hasClass('gf_to-datePicker')) {
    $formElement.gfDatePicker({
      title: _title,
      onOpacity: function () {
        _this.onOpacity();
      },
      offOpacity: function () {
        _this.offOpacity();
      },
    });
  } else if ($formElement.hasClass('gf_to-align')) {
    const $options = $formElement.children('option');
    let dataValue = '';
    let dataColumns = '';
    for (let m = 0; m < $options.length; m++) {
      dataValue += $($options[m]).attr('value') + ',';
      if ($($options[m]).attr('value') == 'left') {
        dataColumns += 'icon-align-left,';
      } else if ($($options[m]).attr('value') == 'center') {
        dataColumns += 'icon-align-center,';
      } else if ($($options[m]).attr('value') == 'right') {
        dataColumns += 'icon-align-right,';
      } else if ($($options[m]).attr('value') == 'justify') {
        dataColumns += 'icon-align-justify,';
      }
    }
    dataValue = dataValue.slice(0, dataValue.length - 1);
    dataColumns = dataColumns.slice(0, dataColumns.length - 1);

    $formElement.attr('data-value', dataValue);
    $formElement.attr('data-columns', dataColumns);
    $formElement.attr('data-icon', 'true');

    $formElement.gfSegment({
      title: _title,
      onSelected: function (value) {},
    });
  } else if ($formElement.is('textarea')) {
    var text = 'true';
    $formElement.gfInputField({
      title: _title,
      text: 'true',
      textarea: true,
    });
  } else if ($formElement.attr('type') == 'text') {
    var text = 'false';
    $formElement.gfInputField({
      title: _title,
      text: 'true',
    });
  } else if ($formElement.is('select')) {
    $formElement.gfDropDown({
      title: _title,
      onOpacity: function () {
        _this.onOpacity();
      },
      offOpacity: function () {
        _this.offOpacity();
      },
    });
  }
}
